import { useLocation } from 'react-router-dom';

export const useCanonicalUrl = () => {
    const { pathname } = useLocation();

    return `${process.env.REACT_APP_BASE_PATH}${pathname}`;
};
